<br />
<highcharts-chart
  [Highcharts]="Highcharts"
  [constructorType]="chartConstructor"
  [options]="chartOptions"
  [oneToOne]="true"
  [update]="updateFlag"
  [callbackFunction]="chartCallback"
  (chartInstance)="onChartInstance($event)"
  style="width: 100%; display: block"
  [ngStyle]="{
    height: dashboardView() ? '200px' : '400px',
    visibility: highChartsData().length > 0 ? 'visible' : 'hidden',
  }"></highcharts-chart>
